import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentsComponent } from './payments.component';
import { PaymentOnbardingProcessComponent } from './payment-onbarding-process/payment-onbarding-process.component';

const routes: Routes = [
  {
    path: '',
    component: PaymentsComponent,
  },
  {
    path: 'onboarding',
    component: PaymentOnbardingProcessComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaymentsRoutingModule {}
